module.exports = __webpack_public_path__ + "static/media/sociallis-icon.734ab06a.png";